export const config: {Username: string, Password: string} = {
    Username: "qa-ideadmin",
    Password: "qa$eek"
}